import { format } from 'date-fns'

// Return a date string in the preferred format used throughout the app
// 2025-05-01 -> May 2025

function formatMonthYearDate(date) {
  if (!date) return date

  return format(date, 'MMM YYYY')
}

export default formatMonthYearDate
